import * as React from 'react';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import {useSelector} from "react-redux";
import {Route, RouteComponentProps, withRouter} from 'react-router';
import {Breadcrumb, Menu, MenuItem} from 'semantic-ui-react';
import * as Routes from '../../../routes';
import {makeGetSidebarSelector} from "../../../Layout/selectors/sidebar";
import BoardOverviewCrumb from "../../../Layout/Breadcrumb/BoardOverviewCrumb";
import UpdatesCrumb from "../../../Layout/Breadcrumb/UpdatesCrumb";
import BoardCrumb from "../../../Layout/Breadcrumb/BoardCrumb";
import BoardTopMenu from "./BoardTopMenu";
import ShareBoardButton from "../ShareBoardButton";

type TopMenuProps =  WithNamespaces & RouteComponentProps<{uid?: string}>;

const TopMenu = (props: TopMenuProps) => {
    const sidebar = useSelector(makeGetSidebarSelector());
    const isBoardWorkspace = Routes.isInspectioBoardWorkspace(props.location.pathname);

    const paddingLeft = isBoardWorkspace? (sidebar.width + 20) + 'px' : '270px';

    return (<Menu fixed="top" inverted={false} id="topmenu" style={{paddingLeft}} className="touch-only-pan">
        <Route path={Routes.inspectio}>
            <MenuItem>
                <Breadcrumb>
                    <Route exact={true} path={[Routes.inspectio, Routes.inspectioBoardWorkspace, Routes.inspectioEditBoard]} component={BoardOverviewCrumb} />
                    <Route exact={true} path={Routes.Updates} component={UpdatesCrumb} />
                    <Route exact={true} path={[Routes.inspectioBoardWorkspace, Routes.inspectioEditBoard]} component={BoardCrumb} />
                </Breadcrumb>
            </MenuItem>
        </Route>
        <Route exact={true} path={Routes.inspectioBoardWorkspace} component={ShareBoardButton} />
        <Menu.Menu position='right' />
        <Route exact={true} path={Routes.inspectioBoardWorkspace} component={BoardTopMenu} />
    </Menu>);
};

export default withNamespaces()(withRouter(TopMenu));
